import { createContext, useState, useEffect } from 'react';
import React from 'react'
import api from '../services/api';
export const FuncoesDisponiveis = createContext();

export function Funcoes({ children }) {

    async function Verificar_Token() {
        try {
            const response = await api.get("Login/verificar-token", { withCredentials: true });
            return true;
        } catch (error) {
            console.log("Erro ao verificar o token:", error);
            return false;
        }
    }

    return (
        <FuncoesDisponiveis.Provider value={{ Verificar_Token }}>
            {children}
        </FuncoesDisponiveis.Provider>
    );
}